import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
var customActions = {
  sendMail: {method: 'POST', url: 'user{/id}/actions/sendMail'},
  enable: {method: 'POST', url: 'user{/id}/actions/enable'},
  finishTutorial: {method: 'PUT', url: 'user{/id}/tutorial/finish'},
  updateBasicAcademicInfo: {method: 'PUT', url: 'user/academic/info'},
  updateUniversityAcademicInfo: {method: 'PUT', url: 'user/university/academic/info'},
  createUser: {method: 'POST', url: 'user/create'}
}
export const UserResource = () => {
  return Vue.resource('user{/id}', {}, customActions)
}



// WEBPACK FOOTER //
// ./src/api/user.js